module.exports = __webpack_public_path__ + "static/media/hexagon.20a9b709.svg";